import React from 'react'
import { FaGithub, FaLinkedin } from "react-icons/fa"
import { HiOutlineMail } from "react-icons/hi"
import { BsFillPersonLinesFill } from "react-icons/bs"

const SocialIcons = () => {

  const links =[
    {
        id: 1,
        icon: (<>
                 LinkedIn <FaLinkedin size={30}/>
               </>),
        href: 'https://linkedin.com/in/prabhat-gupta-064bb0218/',
        style: 'rounded-tr-md'
    },
    {
        id: 2,
        icon: (<>
                 GitHub <FaGithub size={30}/>
               </>),
        href: 'https://github.com/prabhatrajangupta123',
    },
    {
        id: 3,
        icon: (<>
                 Mail <HiOutlineMail size={30}/>
               </>),
        href: 'mailto:prabhatrajangupta9636@gmail.com',
    },
    {
        id: 4,
        icon: (<>
                 Resume <BsFillPersonLinesFill size={30}/>
               </>),
        href: '/MyResume.pdf',
        style: 'rounded-br-md',
        download: true,
    }
  ];

  return (
    <div className='hidden lg:flex flex-col top-[35%] left-0 fixed'>
      <ul>
        {links.map(({id, icon, href, style, download}) => (
            <li key={id} className={'flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-gray-500 ' + style}>
                <a 
                href={href} 
                className='flex justify-between items-center w-full text-white' 
                download={download}
                target='_blank' 
                rel='noreferrer'
                >
                    {icon}
                </a>
            </li>
        ))}
      </ul>
    </div>
  )
}

export default SocialIcons
